// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"SideTabs_tabsWrapper__WTyTd","tab":"SideTabs_tab__NMKce","active":"SideTabs_active__preeH"};